"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
var moment = require("moment");
exports.formatDate = function (date, format) {
    var stringFormat = format || "Do MMMM YYYY, h:mm:ss";
    return moment(date, "YYYY-MM-DD HH:mm").format(format);
};
//# sourceMappingURL=format-date.js.map